export function setSize(size = 'lg') {
  $('#customPopUp .modal-dialog').removeClass('modal-lg modal-sm modal-md').addClass(`modal-${size}`);
}

export function setTitle(title) {
  $('#customPopUpTitle').html(title || '');
}

export function showTitle() {
  $('.modal-header').show();
}

export function show(cb = () => {}) {
  $('#customPopUp').one('shown.bs.modal', cb).modal('show');
}

export function hide() {
  $('#customPopUp').modal('hide');
  $('#customPopUpBody').removeClass('text-center text-left text-right');
  $('#customPopUp .modal-dialog').removeClass('modal-dialog-centered');
}

export function html(content) {
  $('#customPopUpBody').html(content || '');
}

export function alignBodyText(align) {
  $('#customPopUpBody').removeClass('text-center text-left text-right').addClass(`text-${align}`);
}

export function alignModalVerticalCenter() {
  $('#customPopUp .modal-dialog').addClass('modal-dialog-centered');
}

export function showFooter() {
  $('#customPopUpFooter').show();
}

export function footerHtml(content = '') {
  const footer = $('#customPopUpFooter');
  if (footer.length > 0) {
    footer.html(content);
  } else {
    console.error('not found css path #customPopUpFooter');
  }
}
